'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LeftMenu$ExternalLink(url, label) {
  this.JS = null;
  this.JR = null;
  this.JS = url;
  this.JR = label;
}
export { $c_Lpresto_LeftMenu$ExternalLink as $c_Lpresto_LeftMenu$ExternalLink };
$p = $c_Lpresto_LeftMenu$ExternalLink.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LeftMenu$ExternalLink;
/** @constructor */
function $h_Lpresto_LeftMenu$ExternalLink() {
}
export { $h_Lpresto_LeftMenu$ExternalLink as $h_Lpresto_LeftMenu$ExternalLink };
$h_Lpresto_LeftMenu$ExternalLink.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_LeftMenu$ExternalLink) && ((this.JS === x$0.JS) && (this.JR === x$0.JR))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "ExternalLink";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.JS;
  }
  if ((n === 1)) {
    return this.JR;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_LeftMenu$ExternalLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iz)));
}
export { $isArrayOf_Lpresto_LeftMenu$ExternalLink as $isArrayOf_Lpresto_LeftMenu$ExternalLink };
var $d_Lpresto_LeftMenu$ExternalLink = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LeftMenu$ExternalLink, "presto.LeftMenu$ExternalLink", ({
  iz: 1,
  iB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_LeftMenu$ExternalLink as $d_Lpresto_LeftMenu$ExternalLink };
//# sourceMappingURL=presto.-Left-Menu$-External-Link.js.map
